import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed inset-0 bg-black bg-opacity-60 flex items-end justify-center z-50 md:items-center md:p-4"
};
const _hoisted_2 = { class: "bg-white w-full h-full md:h-auto md:max-w-lg md:rounded-xl shadow-2xl md:max-h-[90vh] transition-transform duration-300 ease-out transform flex flex-col" };
const _hoisted_3 = { class: "flex items-center justify-between p-6 border-b border-gray-200 bg-white sticky top-0 z-10 flex-shrink-0" };
const _hoisted_4 = { class: "text-xl font-bold text-gray-900" };
const _hoisted_5 = { class: "flex-1 overflow-y-auto" };
const _hoisted_6 = {
    key: 0,
    class: "p-4 border-b bg-amber-50 border-amber-200"
};
const _hoisted_7 = { class: "flex items-center justify-center" };
const _hoisted_8 = { class: "text-center" };
const _hoisted_9 = { class: "p-6 space-y-6" };
const _hoisted_10 = {
    key: 0,
    class: "mb-4 mt-4"
};
const _hoisted_11 = { class: "flex flex-wrap gap-2" };
const _hoisted_12 = { class: "text-center p-8 bg-gray-50 rounded-lg border-2 border-gray-200" };
const _hoisted_13 = { class: "text-gray-600" };
const _hoisted_14 = {
    key: 3,
    class: "bg-white border border-gray-200 rounded-lg p-4"
};
const _hoisted_15 = { class: "grid grid-cols-1 gap-2" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "text-sm font-medium" };
const _hoisted_18 = { class: "text-xs text-gray-500" };
const _hoisted_19 = { class: "p-6 border-t border-gray-200 bg-gray-50 flex-shrink-0" };
const _hoisted_20 = { class: "flex" };
const _hoisted_21 = {
    key: 0,
    class: "fas fa-spinner fa-spin mr-2"
};
const _hoisted_22 = {
    key: 1,
    class: "fas fa-check mr-2"
};
import { ref, computed, watch, watchEffect, onMounted, onUnmounted } from 'vue';
import { useCheckoutStore } from '../../stores/checkout-store';
import { useTheme } from '@shared/composables/useTheme';
import AdminRangeSlider from './AdminRangeSlider.vue';
const DAY_END_MINUTES = (23 * 60) + 59;
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeSelectionModalStore',
    props: {
        isOpen: { type: Boolean },
        modelValue: {}
    },
    emits: ["update:isOpen", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // 🎨 Theme System
        const { theme } = useTheme();
        // ✅ CHECKOUT STORE: Zentrale Datenquelle
        const checkoutStore = useCheckoutStore();
        // Local state für einzelne Zeit
        const selectedTime = ref('');
        // ✅ ADMIN RANGE SLIDER: Slider value state
        const sliderValue = ref(null);
        // ✅ LIVE TIME UPDATE: Aktueller Zeitpunkt wird jede Minute aktualisiert
        const currentTime = ref(new Date());
        const updateInterval = ref(null);
        // Lifecycle für automatische Zeit-Updates
        onMounted(() => {
            updateInterval.value = setInterval(() => {
                currentTime.value = new Date();
            }, 60000); // 60 Sekunden
        });
        onUnmounted(() => {
            if (updateInterval.value) {
                clearInterval(updateInterval.value);
            }
        });
        // Zeit-Hilfsfunktionen
        const timeToMinutes = (time) => {
            if (!time || !time.includes(':'))
                return 0;
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        };
        const minutesToTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };
        const addMinutesToTime = (time, minutesToAdd) => {
            const totalMinutes = timeToMinutes(time) + minutesToAdd;
            return minutesToTime(totalMinutes);
        };
        // ✅ STORE-BASED: Standard-Zeit aus Store-Daten
        const defaultTime = computed(() => {
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            if (checkoutStore.isLoading) {
                return selectedTime.value || '21:00';
            }
            // ✅ STORE-BASED: Verwende die exakten Server-berechneten Zeiten, aber nur wenn sie in der Zukunft liegen
            if (checkoutStore.orderType === 'pickup' && checkoutStore.estimatedPickupTime !== 'Wird berechnet...') {
                // ✅ FIX: Bei Zeitfenstern wie "17:20 - 20:25 Uhr" das ENDE nehmen (20:25)
                const timeRangeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})/);
                let timeToUse;
                let estimatedMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm das Ende (z.B. "17:20 - 20:25" → 20:25)
                    timeToUse = timeRangeMatch[2];
                    estimatedMinutes = timeToMinutes(timeToUse);
                    console.log(`🎯 DefaultTime: Using END of pickup time range: ${timeToUse} (from: "${checkoutStore.estimatedPickupTime}")`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    timeToUse = singleTimeMatch[1];
                    estimatedMinutes = timeToMinutes(timeToUse);
                    console.log(`🎯 DefaultTime: Using single pickup time: ${timeToUse} (from: "${checkoutStore.estimatedPickupTime}")`);
                }
                else {
                    console.warn(`⚠️ DefaultTime: Could not parse pickup time: "${checkoutStore.estimatedPickupTime}"`);
                    timeToUse = '';
                    estimatedMinutes = 0;
                }
                // ✅ ZEITVALIDIERUNG: Nur verwenden wenn in der Zukunft
                if (timeToUse && estimatedMinutes > nowMinutes) {
                    return timeToUse;
                }
                else if (timeToUse) {
                    console.warn(`⚠️ DefaultTime: Server pickup time ${timeToUse} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            if (checkoutStore.orderType === 'delivery' && checkoutStore.estimatedDeliveryTime !== 'Wird berechnet...') {
                // ✅ FIX: Bei Zeitfenstern wie "20:25 - 21:45 Uhr" das ENDE nehmen (21:45)
                const timeRangeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})/);
                let timeToUse;
                let estimatedMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm das Ende (z.B. "20:25 - 21:45" → 21:45)
                    timeToUse = timeRangeMatch[2];
                    estimatedMinutes = timeToMinutes(timeToUse);
                    console.log(`🎯 DefaultTime: Using END of delivery time range: ${timeToUse} (from: "${checkoutStore.estimatedDeliveryTime}")`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    timeToUse = singleTimeMatch[1];
                    estimatedMinutes = timeToMinutes(timeToUse);
                    console.log(`🎯 DefaultTime: Using single delivery time: ${timeToUse} (from: "${checkoutStore.estimatedDeliveryTime}")`);
                }
                else {
                    console.warn(`⚠️ DefaultTime: Could not parse delivery time: "${checkoutStore.estimatedDeliveryTime}"`);
                    timeToUse = '';
                    estimatedMinutes = 0;
                }
                // ✅ ZEITVALIDIERUNG: Nur verwenden wenn in der Zukunft
                if (timeToUse && estimatedMinutes > nowMinutes) {
                    return timeToUse;
                }
                else if (timeToUse) {
                    console.warn(`⚠️ DefaultTime: Server delivery time ${timeToUse} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            // Fallback: Aktuelle Zeit + Standard-Puffer
            const leadTime = checkoutStore.orderType === 'pickup' ? 30 : 60;
            const fallbackTime = new Date(currentTime.value.getTime() + leadTime * 60000);
            const fallbackTimeString = `${String(fallbackTime.getHours()).padStart(2, '0')}:${String(fallbackTime.getMinutes()).padStart(2, '0')}`;
            console.log(`🔄 DefaultTime: Using fallback time: ${fallbackTimeString} (current + ${leadTime}min buffer)`);
            return fallbackTimeString;
        });
        // Current selection for display
        const currentSelection = computed(() => {
            if (props.modelValue.time) {
                return {
                    startTime: props.modelValue.time,
                    endTime: addMinutesToTime(props.modelValue.time, 30),
                    time: props.modelValue.time
                };
            }
            else if (props.modelValue.startTime && props.modelValue.endTime) {
                return {
                    startTime: props.modelValue.startTime,
                    endTime: props.modelValue.endTime,
                    time: props.modelValue.startTime
                };
            }
            return null;
        });
        // Quick selection options
        const quickSelections = computed(() => {
            const start = defaultTime.value;
            const selections = [
                {
                    label: 'So schnell wie möglich',
                    description: 'Automatische Zeitberechnung',
                    icon: 'fas fa-rocket',
                    isReset: true, // Spezielle Behandlung
                    getTime: () => start
                }
            ];
            return selections.filter(s => s.isReset || timeToMinutes(s.getTime()) < 22 * 60);
        });
        // Validation für Time-Selection
        const isSelectionValid = computed(() => {
            return selectedTime.value && selectedTime.value.length > 0;
        });
        // Format single time for display
        const formatSingleTime = (time) => {
            return time;
        };
        // ✅ SLIDER RANGE: Öffnungszeiten ± 15min Puffer
        const sliderMinMinutes = computed(() => {
            if (checkoutStore.operatingHours?.length) {
                // Verwende die erste Öffnungszeit - 15min als Minimum
                const firstOpenMinutes = timeToMinutes(checkoutStore.operatingHours[0].open);
                return Math.min(DAY_END_MINUTES, Math.max(0, firstOpenMinutes - 15));
            }
            // Fallback: Aktuelle Zeit - 15min
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            return Math.min(DAY_END_MINUTES, Math.max(0, nowMinutes - 15));
        });
        const sliderMaxMinutes = computed(() => {
            if (checkoutStore.operatingHours?.length) {
                // Verwende die letzte Schließzeit + 15min als Maximum
                const lastCloseMinutes = timeToMinutes(checkoutStore.operatingHours[checkoutStore.operatingHours.length - 1].close);
                return Math.min(DAY_END_MINUTES, lastCloseMinutes + 15);
            }
            // Fallback: Aktuelle Zeit + 6 Stunden
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            return Math.min(DAY_END_MINUTES, nowMinutes + (6 * 60));
        });
        // ✅ STORE-BASED: Berechnung der verfügbaren Zeit basierend auf Server-Daten
        const earliestAvailableTime = computed(() => {
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            console.log(`🕐 EarliestAvailableTime: Current time is ${minutesToTime(nowMinutes)} (${nowMinutes}min)`);
            // ✅ STORE-BASED: Verwende Server-berechnete Zeit falls verfügbar, aber nur wenn sie in der Zukunft liegt
            if (checkoutStore.orderType === 'pickup' && checkoutStore.estimatedPickupTime !== 'Wird berechnet...') {
                // ✅ FIX: Bei Zeitfenstern wie "17:25 - 17:30 Uhr" den ANFANG nehmen (17:25) - nicht das Ende!
                const timeRangeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})/);
                let estimatedMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm den ANFANG (z.B. "17:25 - 17:30" → 17:25)
                    estimatedMinutes = timeToMinutes(timeRangeMatch[1]);
                    console.log(`🎯 EarliestAvailableTime: Using START of pickup time range: ${timeRangeMatch[1]} (${estimatedMinutes}min) from "${checkoutStore.estimatedPickupTime}"`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    estimatedMinutes = timeToMinutes(singleTimeMatch[1]);
                    console.log(`🎯 EarliestAvailableTime: Using single pickup time: ${singleTimeMatch[1]} (${estimatedMinutes}min) from "${checkoutStore.estimatedPickupTime}"`);
                }
                else {
                    console.warn(`⚠️ EarliestAvailableTime: Could not parse pickup time: "${checkoutStore.estimatedPickupTime}"`);
                    estimatedMinutes = nowMinutes + 30; // Fallback
                }
                // ✅ ZEITVALIDIERUNG: Server-Zeit muss in der Zukunft liegen
                if (estimatedMinutes > nowMinutes) {
                    return estimatedMinutes;
                }
                else {
                    console.warn(`⚠️ EarliestAvailableTime: Server pickup time ${minutesToTime(estimatedMinutes)} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            if (checkoutStore.orderType === 'delivery' && checkoutStore.estimatedDeliveryTime !== 'Wird berechnet...') {
                // ✅ FIX: Bei Zeitfenstern wie "20:25 - 21:45 Uhr" das ENDE nehmen (21:45)
                const timeRangeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})/);
                let estimatedMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm das Ende (z.B. "20:25 - 21:45" → 21:45)
                    estimatedMinutes = timeToMinutes(timeRangeMatch[1]);
                    console.log(`🎯 EarliestAvailableTime: Using START of delivery time range: ${timeRangeMatch[1]} (${estimatedMinutes}min) from "${checkoutStore.estimatedDeliveryTime}"`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    estimatedMinutes = timeToMinutes(singleTimeMatch[1]);
                    console.log(`🎯 EarliestAvailableTime: Using single delivery time: ${singleTimeMatch[1]} (${estimatedMinutes}min) from "${checkoutStore.estimatedDeliveryTime}"`);
                }
                else {
                    console.warn(`⚠️ EarliestAvailableTime: Could not parse delivery time: "${checkoutStore.estimatedDeliveryTime}"`);
                    estimatedMinutes = nowMinutes + 60; // Fallback
                }
                // ✅ ZEITVALIDIERUNG: Server-Zeit muss in der Zukunft liegen
                if (estimatedMinutes > nowMinutes) {
                    return estimatedMinutes;
                }
                else {
                    console.warn(`⚠️ EarliestAvailableTime: Server delivery time ${minutesToTime(estimatedMinutes)} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            // Fallback: Aktuelle Zeit + Standard-Puffer
            const bufferMinutes = checkoutStore.orderType === 'pickup' ? 30 : 60;
            const fallbackMinutes = nowMinutes + bufferMinutes;
            console.log(`🔄 EarliestAvailableTime: Using fallback: ${minutesToTime(fallbackMinutes)} (current + ${bufferMinutes}min buffer)`);
            return fallbackMinutes;
        });
        // ✅ NEUE COMPUTED: Ende des orangenen Pufferbereichs (für Zeitfenster wie "20-25 Min")
        const bufferEndTime = computed(() => {
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            console.log(`🟠 BufferEndTime: Computing end of orange buffer...`);
            // ✅ PICKUP: Bei Zeitfenstern das ENDE nehmen (für orangenen Bereich)
            if (checkoutStore.orderType === 'pickup' && checkoutStore.estimatedPickupTime !== 'Wird berechnet...') {
                const timeRangeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})/);
                let bufferEndMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm das ENDE für den orangenen Bereich (z.B. "15:20 - 15:25" → 15:25)
                    bufferEndMinutes = timeToMinutes(timeRangeMatch[2]);
                    console.log(`🟠 BufferEndTime: Using END of pickup time range: ${timeRangeMatch[2]} (${bufferEndMinutes}min) from "${checkoutStore.estimatedPickupTime}"`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    bufferEndMinutes = timeToMinutes(singleTimeMatch[1]);
                    console.log(`🟠 BufferEndTime: Using single pickup time: ${singleTimeMatch[1]} (${bufferEndMinutes}min) from "${checkoutStore.estimatedPickupTime}"`);
                }
                else {
                    console.warn(`⚠️ BufferEndTime: Could not parse pickup time: "${checkoutStore.estimatedPickupTime}"`);
                    bufferEndMinutes = nowMinutes + 30; // Fallback
                }
                // ✅ ZEITVALIDIERUNG: Buffer-Ende muss in der Zukunft liegen
                if (bufferEndMinutes > nowMinutes) {
                    return bufferEndMinutes;
                }
                else {
                    console.warn(`⚠️ BufferEndTime: Server pickup end time ${minutesToTime(bufferEndMinutes)} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            // ✅ DELIVERY: Bei Zeitfenstern das ENDE nehmen
            if (checkoutStore.orderType === 'delivery' && checkoutStore.estimatedDeliveryTime !== 'Wird berechnet...') {
                const timeRangeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                const singleTimeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})/);
                let bufferEndMinutes;
                if (timeRangeMatch) {
                    // Zeitfenster: Nimm das Ende (z.B. "20:25 - 21:45" → 21:45)
                    bufferEndMinutes = timeToMinutes(timeRangeMatch[2]);
                    console.log(`🟠 BufferEndTime: Using END of delivery time range: ${timeRangeMatch[2]} (${bufferEndMinutes}min) from "${checkoutStore.estimatedDeliveryTime}"`);
                }
                else if (singleTimeMatch) {
                    // Einzelzeit: Nimm die Zeit direkt
                    bufferEndMinutes = timeToMinutes(singleTimeMatch[1]);
                    console.log(`🟠 BufferEndTime: Using single delivery time: ${singleTimeMatch[1]} (${bufferEndMinutes}min) from "${checkoutStore.estimatedDeliveryTime}"`);
                }
                else {
                    console.warn(`⚠️ BufferEndTime: Could not parse delivery time: "${checkoutStore.estimatedDeliveryTime}"`);
                    bufferEndMinutes = nowMinutes + 60; // Fallback
                }
                // ✅ ZEITVALIDIERUNG: Buffer-Ende muss in der Zukunft liegen
                if (bufferEndMinutes > nowMinutes) {
                    return bufferEndMinutes;
                }
                else {
                    console.warn(`⚠️ BufferEndTime: Server delivery end time ${minutesToTime(bufferEndMinutes)} is in the past (now: ${minutesToTime(nowMinutes)}), using fallback`);
                }
            }
            // Fallback: earliestAvailableTime (falls kein Zeitfenster vorhanden)
            const fallbackBufferEnd = earliestAvailableTime.value;
            console.log(`🔄 BufferEndTime: Using fallback (same as earliestAvailable): ${minutesToTime(fallbackBufferEnd)}`);
            return fallbackBufferEnd;
        });
        // ✅ INTELLIGENT BACKGROUND RANGES: Store-basierte Implementation
        const intelligentBackgroundRanges = computed(() => {
            const ranges = [];
            const nowMinutes = currentTime.value.getHours() * 60 + currentTime.value.getMinutes();
            const earliestValid = earliestAvailableTime.value;
            console.log(`🎨 IntelligentBackgroundRanges: Computing ranges...`);
            console.log(`🕐 Current: ${minutesToTime(nowMinutes)}, Earliest: ${minutesToTime(earliestValid)}, Operating Hours: ${checkoutStore.operatingHours?.length || 0}`);
            if (!checkoutStore.operatingHours?.length) {
                console.log(`⚠️ IntelligentBackgroundRanges: No operating hours, using fallback`);
                // Fallback: Keine Öffnungszeiten verfügbar
                ranges.push({
                    start: earliestValid,
                    end: sliderMaxMinutes.value,
                    label: 'Verfügbar',
                    color: 'green'
                });
                return ranges;
            }
            console.log(`🏪 IntelligentBackgroundRanges: Processing ${checkoutStore.operatingHours.length} operating hour periods`);
            // ✅ SCHRITT 1: Öffnungszeiten als graue Hintergrund-Bereiche (nur für nicht-abgelaufene)
            for (const hours of checkoutStore.operatingHours) {
                const openMinutes = timeToMinutes(hours.open);
                const closeMinutes = timeToMinutes(hours.close);
                console.log(`📅 Operating Hours: ${hours.open}-${hours.close} (${openMinutes}-${closeMinutes}min)`);
                // ✅ FIX: Nur nicht-abgelaufene Öffnungszeiten als grauer Hintergrund
                if (closeMinutes > nowMinutes && closeMinutes >= sliderMinMinutes.value && openMinutes <= sliderMaxMinutes.value) {
                    // ✅ KORREKTUR: Range startet bei Öffnungszeit (17:00), nicht bei sliderMin (16:45)
                    const rangeStart = openMinutes; // Direkt die Öffnungszeit verwenden
                    const rangeEnd = Math.min(closeMinutes, sliderMaxMinutes.value);
                    if (rangeStart < rangeEnd) {
                        console.log(`🏪 Adding background range: ${minutesToTime(rangeStart)}-${minutesToTime(rangeEnd)}`);
                        ranges.push({
                            start: rangeStart,
                            end: rangeEnd,
                            label: `Öffnungszeiten ${hours.open}-${hours.close}`,
                            color: 'gray'
                        });
                    }
                }
            }
            // ✅ SCHRITT 2: Vergangene Zeiten (dunkelgrau) - nur für abgelaufene Bereiche
            for (const hours of checkoutStore.operatingHours) {
                const openMinutes = timeToMinutes(hours.open);
                const closeMinutes = timeToMinutes(hours.close);
                // Nur für Bereiche die die aktuelle Zeit überlappen oder komplett vergangen sind
                if (openMinutes <= nowMinutes && closeMinutes >= sliderMinMinutes.value) {
                    const pastStart = Math.max(openMinutes, sliderMinMinutes.value);
                    const pastEnd = Math.min(nowMinutes, closeMinutes, sliderMaxMinutes.value);
                    if (pastStart < pastEnd) {
                        console.log(`⌛ Adding past range: ${minutesToTime(pastStart)}-${minutesToTime(pastEnd)}`);
                        ranges.push({
                            start: pastStart,
                            end: pastEnd,
                            label: 'Vergangen',
                            color: 'darkgray'
                        });
                    }
                }
            }
            // ✅ SCHRITT 3: Orange Pufferzeit - nur für zukünftige Zeiten IN den Öffnungszeiten
            if (nowMinutes < bufferEndTime.value && bufferEndTime.value <= sliderMaxMinutes.value) {
                // ✅ KORREKTUR: Pufferzeit startet bei Öffnungszeit, nicht bei sliderMin
                const firstOpenMinutes = checkoutStore.operatingHours?.length ? timeToMinutes(checkoutStore.operatingHours[0].open) : nowMinutes;
                const bufferStart = Math.max(firstOpenMinutes, nowMinutes); // Öffnungszeit oder jetzt
                const bufferEnd = bufferEndTime.value; // ✅ FIX: Verwende bufferEndTime statt earliestValid
                if (bufferStart < bufferEnd) {
                    const bufferMinutes = bufferEndTime.value - nowMinutes;
                    const bufferLabel = checkoutStore.orderType === 'delivery'
                        ? `Vorbereitung (${bufferMinutes}min Lieferzeit)`
                        : `Vorbereitung (${bufferMinutes}min)`;
                    console.log(`🟠 Adding buffer range: ${minutesToTime(bufferStart)}-${minutesToTime(bufferEnd)} (${bufferLabel})`);
                    ranges.push({
                        start: bufferStart,
                        end: bufferEnd,
                        label: bufferLabel,
                        color: 'orange'
                    });
                }
            }
            // ✅ SCHRITT 4: Grüne verfügbare Zeiten - nur bis zur echten Schließzeit
            console.log(`🟢 Computing available (green) ranges...`);
            for (const hours of checkoutStore.operatingHours) {
                const openMinutes = timeToMinutes(hours.open);
                const closeMinutes = timeToMinutes(hours.close);
                // ✅ FIX: Verfügbare Zeit muss nach bufferEndTime sein (Ende des orangenen Bereichs)
                const validStart = Math.max(openMinutes, bufferEndTime.value, nowMinutes);
                // ✅ KORREKT: Verfügbare Zeit nur bis zur echten Schließzeit (ohne +15min)
                if (validStart < closeMinutes && validStart >= sliderMinMinutes.value && validStart <= sliderMaxMinutes.value) {
                    const rangeEnd = Math.min(closeMinutes, sliderMaxMinutes.value);
                    console.log(`🟢 Adding available range: ${minutesToTime(validStart)}-${minutesToTime(rangeEnd)} for ${hours.open}-${hours.close}`);
                    ranges.push({
                        start: validStart,
                        end: rangeEnd,
                        label: `Verfügbar ${hours.open}-${hours.close}`,
                        color: 'green'
                    });
                }
                else {
                    console.log(`❌ Skipping range ${hours.open}-${hours.close}: validStart=${minutesToTime(validStart)}, closeMinutes=${minutesToTime(closeMinutes)}, now=${minutesToTime(nowMinutes)}`);
                }
            }
            console.log(`🎨 IntelligentBackgroundRanges: Generated ${ranges.length} ranges`);
            return ranges;
        });
        // ✅ VERFÜGBARE BEREICHE: Nur grüne Bereiche
        const availableRanges = computed(() => {
            return intelligentBackgroundRanges.value.filter(range => range.color === 'green');
        });
        const hasAvailableTime = computed(() => {
            return availableRanges.value.length > 0 && sliderMaxMinutes.value > sliderMinMinutes.value;
        });
        // ✅ VORBESTELLUNG: Geschlossen-jetzt + Vorbestellungen erlaubt + wählbarer Slot.
        const isPreOrderContext = computed(() => {
            const openingHours = checkoutStore.openingHoursInfo;
            const closedNow = Boolean(openingHours && openingHours.isWithinHours === false);
            return closedNow && checkoutStore.allowPreOrders && hasAvailableTime.value;
        });
        const isBlockedByOpeningHours = computed(() => {
            const openingHours = checkoutStore.openingHoursInfo;
            const closedNow = Boolean(openingHours && openingHours.isWithinHours === false);
            if (!closedNow)
                return false;
            // ✅ VORBESTELLUNG: Geschlossen blockiert die Zeitauswahl nur dann, wenn das
            // Projekt keine Vorbestellungen erlaubt ODER es keinen wählbaren Slot gibt
            // (z.B. heute schon geschlossen). Andernfalls darf der Kunde einen späteren
            // Slot wählen; der Server validiert die Zeit final.
            if (!checkoutStore.allowPreOrders)
                return true;
            return !hasAvailableTime.value;
        });
        const openingHoursBlockedMessage = computed(() => {
            const restaurantMessage = checkoutStore.pricingData?.data?.restaurantStatus?.message;
            if (restaurantMessage) {
                return restaurantMessage;
            }
            const openingHours = checkoutStore.openingHoursInfo;
            return (openingHours?.message ||
                `${checkoutStore.orderType === 'pickup' ? 'Abholung' : 'Lieferung'} ist aktuell außerhalb der Öffnungszeiten nicht möglich.`);
        });
        const constrainedSliderMin = computed(() => {
            return sliderMinMinutes.value;
        });
        const constrainedSliderMax = computed(() => {
            return sliderMaxMinutes.value;
        });
        // Format time for slider display
        const formatSliderValue = (minutes) => {
            return minutesToTime(minutes);
        };
        // Convert selected time to minutes for slider
        const selectedTimeMinutes = computed({
            get: () => {
                if (selectedTime.value && selectedTime.value.length > 0) {
                    return timeToMinutes(selectedTime.value);
                }
                return timeToMinutes(defaultTime.value);
            },
            set: (minutes) => {
                selectedTime.value = minutesToTime(minutes);
            }
        });
        // Quick selection handler
        const selectQuickTime = (getTime) => {
            const time = getTime();
            selectedTime.value = time;
        };
        // ✅ RESET FUNCTION: "So schnell wie möglich" setzt Zeit zurück
        const selectAsFastAsPossible = () => {
            console.log('🚀 [TimeSelectionModal] "So schnell wie möglich" selected - resetting time');
            // ✅ 1. Lösche gewählte Zeit im Store für aktuellen Order Type
            checkoutStore.clearSelectedTime();
            // ✅ 2. Lösche lokale Modal-Werte
            selectedTime.value = '';
            sliderValue.value = null;
            // ✅ 3. Emit leeres modelValue für Legacy-Komponenten
            emit('update:modelValue', {
                startTime: '',
                endTime: '',
                time: ''
            });
            console.log('✅ [TimeSelectionModal] Cleared selected time and slider values');
            // ✅ 4. Schließe Modal (keine spezifische Zeit gesetzt)
            closeModal();
        };
        // Bestätigen mit Server-Validierung
        const confirmSelection = async () => {
            // Confirm button acts as the only close action for the modal.
            // If no valid/selectable time is available, just close without changing selection.
            if (!isSelectionValid.value || checkoutStore.isLoading || checkoutStore.timeValidationLoading || isBlockedByOpeningHours.value) {
                closeModal();
                return;
            }
            // ✅ SERVER-VALIDIERUNG: Prüfe Zeit mit Server bevor sie gesetzt wird
            console.log('🔍 [TimeSelectionModal] Validating selected time with server:', {
                selectedTime: selectedTime.value,
                orderType: checkoutStore.orderType
            });
            try {
                const validationResult = await checkoutStore.setSelectedTimeWithValidation(selectedTime.value);
                if (validationResult.success) {
                    console.log('✅ [TimeSelectionModal] Time validated and saved:', {
                        requestedTime: selectedTime.value,
                        validatedTime: validationResult.validatedTime,
                        orderType: checkoutStore.orderType
                    });
                    // ✅ LEGACY: Emit für bestehende Komponenten mit validierter Zeit
                    const finalTime = validationResult.validatedTime || selectedTime.value;
                    emit('update:modelValue', {
                        startTime: finalTime,
                        endTime: addMinutesToTime(finalTime, 30),
                        time: finalTime
                    });
                    closeModal();
                }
                else {
                    // ✅ VALIDIERUNGSFEHLER: Zeige Fehlermeldung
                    console.log('❌ [TimeSelectionModal] Time validation failed:', validationResult.error);
                    // Hier könntest du eine Toast-Benachrichtigung oder Fehlermeldung anzeigen
                    alert(`Zeitvalidierung fehlgeschlagen: ${validationResult.error}`);
                    closeModal();
                }
            }
            catch (error) {
                console.error('❌ [TimeSelectionModal] Validation error:', error);
                alert(`Fehler bei der Zeitvalidierung: ${error.message || error}`);
                closeModal();
            }
        };
        // Modal schließen
        const closeModal = () => {
            emit('update:isOpen', false);
        };
        // ✅ DEBUG FUNCTIONS: Für Abhol/Lieferzeit Debugging
        const debugRefreshStoreData = () => {
            console.log('🔄 Debug: Manually refreshing store data...');
            // Force re-computation von allen computed values
            currentTime.value = new Date();
            // Log current store state
            console.log('📊 Current Store State:', {
                orderType: checkoutStore.orderType,
                isLoading: checkoutStore.isLoading,
                estimatedPickupTime: checkoutStore.estimatedPickupTime,
                estimatedDeliveryTime: checkoutStore.estimatedDeliveryTime,
                operatingHours: checkoutStore.operatingHours
            });
        };
        const debugLogStoreState = () => {
            console.group('📝 Complete Store Debug Information');
            console.log('Order Type:', checkoutStore.orderType);
            console.log('Loading:', checkoutStore.isLoading);
            console.log('Estimated Pickup Time:', checkoutStore.estimatedPickupTime);
            console.log('Estimated Delivery Time:', checkoutStore.estimatedDeliveryTime);
            console.log('Operating Hours:', checkoutStore.operatingHours);
            console.log('Selected Time:', selectedTime.value);
            console.log('Default Time:', defaultTime.value);
            console.log('Current Time:', currentTime.value);
            console.log('Earliest Available Time:', earliestAvailableTime.value, '(' + minutesToTime(earliestAvailableTime.value) + ')');
            console.log('Slider Value:', sliderValue.value);
            console.log('Background Ranges:', intelligentBackgroundRanges.value);
            console.log('Available Ranges:', availableRanges.value);
            console.groupEnd();
        };
        const debugSetTestTime = () => {
            console.log('⏰ Debug: Setting test estimated times...');
            // Setze Test-Zeiten im Store
            if (checkoutStore.orderType === 'pickup') {
                console.log('Setting test pickup time to 18:30 Uhr');
                checkoutStore.estimatedPickupTime = '18:30 Uhr';
            }
            else {
                console.log('Setting test delivery time to 19:15 - 19:45 Uhr');
                checkoutStore.estimatedDeliveryTime = '19:15 - 19:45 Uhr';
            }
        };
        const isDevEnvironment = typeof window !== 'undefined' && Boolean(import.meta?.env?.DEV);
        if (isDevEnvironment) {
            window.__timeSelectionDebug__ = {
                refreshStoreData: debugRefreshStoreData,
                logStoreState: debugLogStoreState,
                setTestTime: debugSetTestTime
            };
        }
        // Initialize mit default time
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                const currentlySelectedTime = props.modelValue?.time || props.modelValue?.startTime;
                if (currentlySelectedTime) {
                    selectedTime.value = currentlySelectedTime;
                }
                else {
                    selectedTime.value = defaultTime.value;
                }
            }
        });
        // Watch für Store-Änderungen
        watch(() => [checkoutStore.estimatedPickupTime, checkoutStore.estimatedDeliveryTime], () => {
            if (props.isOpen) {
                console.log('🔄 Store times changed, updating modal');
                selectedTime.value = defaultTime.value;
            }
        }, { deep: true });
        // ✅ ADMIN RANGE SLIDER: Validierung der Slider-Werte
        watchEffect(() => {
            // Stelle sicher, dass der Slider-Wert innerhalb der verfügbaren Bereiche liegt
            if (availableRanges.value.length > 0 && sliderValue.value !== null) {
                const isValidTime = availableRanges.value.some(range => sliderValue.value >= range.start && sliderValue.value <= range.end);
                if (!isValidTime) {
                    // Setze auf die erste verfügbare Zeit
                    const firstRange = availableRanges.value[0];
                    if (firstRange) {
                        sliderValue.value = firstRange.start;
                        // Update auch selectedTime
                        selectedTime.value = minutesToTime(firstRange.start);
                    }
                }
            }
        });
        // ✅ SLIDER VALUE SYNC: Synchronisiere Slider mit selectedTime
        watch(() => sliderValue.value, (newValue) => {
            if (newValue !== null) {
                selectedTime.value = minutesToTime(newValue);
            }
        });
        watch(() => selectedTime.value, (newTime) => {
            if (newTime) {
                sliderValue.value = timeToMinutes(newTime);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_ctx.isOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createCommentVNode(" Mobile: Vollbild von unten, Desktop: normales Modal "),
                        _createElementVNode("div", _hoisted_2, [
                            _createCommentVNode(" Header "),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h2", _hoisted_4, [
                                    _createElementVNode("i", {
                                        class: "fas fa-clock mr-2",
                                        style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                    }, null, 4 /* STYLE */),
                                    _createTextVNode(" " + _toDisplayString(_unref(checkoutStore).orderType === 'pickup' ? 'Abholzeit wählen' : 'Lieferzeit wählen'), 1 /* TEXT */)
                                ])
                            ]),
                            _createCommentVNode(" Content "),
                            _createElementVNode("div", _hoisted_5, [
                                _createCommentVNode(" ✅ VORBESTELLUNG-HINWEIS: Restaurant aktuell geschlossen, Vorbestellung möglich "),
                                (isPreOrderContext.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                                            _createElementVNode("div", { class: "flex items-start gap-3" }, [
                                                _createElementVNode("i", { class: "fas fa-calendar-clock text-amber-600 mt-0.5" }),
                                                _createElementVNode("div", { class: "text-sm text-amber-800" }, [
                                                    _createElementVNode("span", { class: "font-semibold" }, "Vorbestellung:"),
                                                    _createTextVNode(" Wir haben gerade geschlossen. Wähle eine Zeit innerhalb der Öffnungszeiten – deine Bestellung wird dann zur gewünschten Zeit zubereitet. ")
                                                ])
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Aktueller Status "),
                                (currentSelection.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "p-6 border-b",
                                        style: _normalizeStyle({
                                            backgroundColor: _unref(theme).colors.primary + '10',
                                            borderColor: _unref(theme).colors.primary + '20'
                                        })
                                    }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("div", {
                                                    class: "w-12 h-12 mx-auto mb-2 flex items-center justify-center rounded-full",
                                                    style: _normalizeStyle({ backgroundColor: _unref(theme).colors.primary + '20' })
                                                }, [
                                                    _createElementVNode("i", {
                                                        class: "fas fa-check",
                                                        style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                                    }, null, 4 /* STYLE */)
                                                ], 4 /* STYLE */),
                                                _createElementVNode("p", {
                                                    class: "text-sm font-medium",
                                                    style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                                }, "Aktuell gewählt", 4 /* STYLE */),
                                                _createElementVNode("p", {
                                                    class: "text-lg font-bold",
                                                    style: _normalizeStyle({ color: _unref(theme).colors.primaryHover })
                                                }, _toDisplayString(formatSingleTime(currentSelection.value.time || currentSelection.value.startTime)), 5 /* TEXT, STYLE */)
                                            ])
                                        ])
                                    ], 4 /* STYLE */))
                                    : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Zeitauswahl-Slider "),
                                _createElementVNode("div", _hoisted_9, [
                                    _createCommentVNode(" ✅ LOADING STATE: Zeige Spinner während API calls "),
                                    (_unref(checkoutStore).isLoading)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "text-center p-8 rounded-lg border-2",
                                            style: _normalizeStyle({
                                                backgroundColor: _unref(theme).colors.primary + '10',
                                                borderColor: _unref(theme).colors.primary + '30'
                                            })
                                        }, [
                                            _createElementVNode("div", {
                                                class: "mb-3",
                                                style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                            }, [...(_cache[2] || (_cache[2] = [
                                                    _createElementVNode("i", { class: "fas fa-spinner fa-spin text-3xl" }, null, -1 /* CACHED */)
                                                ]))], 4 /* STYLE */),
                                            _createElementVNode("h3", {
                                                class: "text-lg font-semibold mb-2",
                                                style: _normalizeStyle({ color: _unref(theme).colors.primaryHover })
                                            }, _toDisplayString(_unref(checkoutStore).orderType === 'pickup' ? 'Abholzeiten' : 'Lieferzeiten') + " werden berechnet... ", 5 /* TEXT, STYLE */),
                                            _createElementVNode("p", {
                                                style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                            }, " Bitte warten Sie einen Moment. ", 4 /* STYLE */)
                                        ], 4 /* STYLE */))
                                        : (hasAvailableTime.value && !isBlockedByOpeningHours.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" ✅ ADMIN RANGE SLIDER: Komplexer Slider mit Background-Ranges "),
                                                _createElementVNode("div", null, [
                                                    _createVNode(AdminRangeSlider, {
                                                        value: selectedTimeMinutes.value,
                                                        "absolute-min": constrainedSliderMin.value,
                                                        "absolute-max": constrainedSliderMax.value,
                                                        "background-ranges": intelligentBackgroundRanges.value,
                                                        "operating-hours": _unref(checkoutStore).operatingHours,
                                                        "format-value": formatSliderValue,
                                                        "show-value": true,
                                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => (selectedTimeMinutes.value = $event))
                                                    }, null, 8 /* PROPS */, ["value", "absolute-min", "absolute-max", "background-ranges", "operating-hours"]),
                                                    _createCommentVNode(" Operating Hours Hinweise "),
                                                    (_unref(checkoutStore).operatingHours?.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-sm text-gray-600 mb-2" }, "Öffnungszeiten heute:", -1 /* CACHED */)),
                                                            _createElementVNode("div", _hoisted_11, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkoutStore).operatingHours, (hours, index) => {
                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                        key: index,
                                                                        class: "px-2 py-1 rounded text-xs",
                                                                        style: _normalizeStyle({
                                                                            backgroundColor: _unref(theme).colors.success + '20',
                                                                            color: _unref(theme).colors.success
                                                                        })
                                                                    }, _toDisplayString(hours.open) + " - " + _toDisplayString(hours.close), 5 /* TEXT, STYLE */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                _createCommentVNode(" Keine verfügbaren Zeiten "),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-gray-400 mb-3" }, [
                                                        _createElementVNode("i", { class: "fas fa-clock text-3xl" })
                                                    ], -1 /* CACHED */)),
                                                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-700 mb-2" }, "Keine Zeiten verfügbar", -1 /* CACHED */)),
                                                    _createElementVNode("p", _hoisted_13, [
                                                        (isBlockedByOpeningHours.value)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(openingHoursBlockedMessage.value), 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(" Für heute sind keine freien " + _toDisplayString(_unref(checkoutStore).orderType === 'pickup' ? 'Abhol' : 'Liefer') + "zeiten mehr verfügbar. Bitte versuchen Sie es später erneut. ", 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                    ])
                                                ])
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                                    _createCommentVNode(" Quick Selection "),
                                    (!_unref(checkoutStore).isLoading && !isBlockedByOpeningHours.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-bolt mr-1 text-yellow-600" }),
                                                _createTextVNode(" Schnellauswahl ")
                                            ], -1 /* CACHED */)),
                                            _createElementVNode("div", _hoisted_15, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickSelections.value, (selection, index) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: index,
                                                        onClick: ($event) => (selection.isReset ? selectAsFastAsPossible() : selectQuickTime(selection.getTime)),
                                                        class: "flex items-center p-3 text-left text-gray-700 border border-gray-200 rounded-lg transition-all duration-200 hover:opacity-90",
                                                        style: _normalizeStyle({
                                                            borderColor: _unref(theme).colors.primary + '20'
                                                        })
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "w-8 h-8 flex items-center justify-center rounded-full mr-3",
                                                            style: _normalizeStyle({ backgroundColor: _unref(theme).colors.primary + '20' })
                                                        }, [
                                                            _createElementVNode("i", {
                                                                class: _normalizeClass([selection.icon, "text-sm"]),
                                                                style: _normalizeStyle({ color: _unref(theme).colors.primary })
                                                            }, null, 6 /* CLASS, STYLE */)
                                                        ], 4 /* STYLE */),
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("div", _hoisted_17, _toDisplayString(selection.label), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_18, _toDisplayString(selection.description), 1 /* TEXT */)
                                                        ])
                                                    ], 12 /* STYLE, PROPS */, _hoisted_16));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createCommentVNode(" Footer / Action Buttons "),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("button", {
                                        onClick: confirmSelection,
                                        class: "w-full px-4 py-2 text-white rounded-lg hover:opacity-90 transition-all duration-200",
                                        style: _normalizeStyle({
                                            backgroundColor: _unref(theme).colors.primary,
                                            borderRadius: _unref(theme).borderRadius
                                        })
                                    }, [
                                        (_unref(checkoutStore).isLoading || _unref(checkoutStore).timeValidationLoading)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_22)),
                                        _createTextVNode(" " + _toDisplayString(_unref(checkoutStore).timeValidationLoading ? 'Validiere Zeit...' :
                                            _unref(checkoutStore).isLoading ? 'Berechne...' :
                                                'Bestätigen'), 1 /* TEXT */)
                                    ], 4 /* STYLE */)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
